// Every English string the recipe card and the method editor show, in one
// place so an Urdu table can be added later without touching the components.
// Plain words, short sentences: the people reading these work in a kitchen.

export const RC = {
  // the button on a line
  open: 'Recipe',
  openFor: (name: string) => `Recipe for ${name}`,

  // the card
  loading: 'Loading the recipe…',
  notFound: 'There is no recipe for this item yet.',
  notFoundHelp: 'It can be added in Menu, under Costing & Recipes.',
  switchedOff: 'Recipes on the kitchen screens are switched off.',
  loadFailed: 'The recipe could not be loaded.',
  tryAgain: 'Try again',
  back: 'Back',
  backTo: (name: string) => `Back to ${name}`,
  close: 'Close',

  making: 'Making',
  amountLabel: 'How much are you making?',
  byPortions: 'Portions',
  byWeight: (unit: string) => `By ${unit === 'liter' || unit === 'ml' ? 'volume' : unit === 'each' || unit === 'dozen' || unit === 'pair' ? 'count' : 'weight'}`,
  chip: (n: number) => `×${n}`,
  chipHelp: (n: number, amount: string) => (n === 1 ? `The recipe as written: ${amount}` : `${n} times the recipe: ${amount}`),
  thisOrder: (amount: string) => `This order: ${amount}`,
  planned: (amount: string) => `Planned: ${amount}`,
  writtenFor: (amount: string) => `Recipe written for ${amount}`,
  badAmount: 'Type how much you are making (more than 0). Showing the recipe as written.',
  options: 'With',

  ingredients: 'Ingredients',
  noIngredients: 'No ingredients are listed for this recipe.',
  madeHere: 'Made here',
  openPrep: (name: string, amount: string) => `Open the recipe for ${name}, ${amount}`,
  from: (names: string[]) => names.join(', '),

  method: 'Method',
  noMethod: 'No method has been written for this recipe.',

  // the method editor (Menu → Costing & Recipes, and the prep item drawer)
  editorTitle: 'Kitchen recipe card',
  editorHelp: 'What the cooks read on the kitchen screens. It does not change the cost or what is deducted from stock.',
  makesLabel: 'The whole recipe makes',
  makesHelp: (servings: number) =>
    `Optional. By weight, volume or count, for all ${servings} serving${servings === 1 ? '' : 's'} together — so the kitchen can scale by kilo as well as by portion.`,
  makesPortion: (amount: string) => `One serving is ${amount}.`,
  makesQty: 'Amount',
  makesUnit: 'Unit',
  noUnit: 'Not stated',
  stepsTitle: 'Method',
  stepsHelp: 'One step per box, in the order they are done. Keep each one short.',
  stepLabel: (n: number) => `Step ${n}`,
  stepPlaceholder: 'What to do',
  addStep: 'Add step',
  removeStep: (n: number) => `Remove step ${n}`,
  moveUp: (n: number) => `Move step ${n} up`,
  moveDown: (n: number) => `Move step ${n} down`,
  save: 'Save recipe card',
  saving: 'Saving…',
  saved: 'Recipe card saved',
  undo: 'Undo changes',
  stepTooLong: (n: number, max: number) => `Step ${n} is too long. Keep it under ${max} characters, or split it in two.`,
  tooManySteps: (max: number) => `A recipe can have at most ${max} steps.`,
  yieldNeedsQty: 'Type how much the recipe makes (more than 0), or set the unit to "Not stated".',
  yieldNeedsUnit: 'Pick the unit for how much the recipe makes.',

  // Settings
  settingTitle: 'Recipes on the kitchen screens',
  settingHelp:
    'Cooks can open a dish on the Kitchen Display or in Kitchen Production and read its recipe: the ingredients, the method, and the amounts for the batch they are making. No prices or costs are shown.',
  settingSwitch: 'Show recipes to the kitchen',
  settingSaved: 'Saved',
  settingOnNote: 'Kitchen screens that are already open pick this up when they are reloaded.',
} as const
